import {Component, AfterViewInit, Output, EventEmitter, OnDestroy, OnInit,Renderer2} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {AssignOppModalComponent} from './assign-opp-modal/assign-opp-modal.component';
import {TransferOppModalComponent} from './transfer-opp-modal/transfer-opp-modal.component';
import {ViewAsModalComponent} from './view-as-modal/view-as-modal.component';

import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from "ngx-bootstrap/modal";

import {ConfigService} from '../shared/services/config.service';
import {HeaderService} from './header.service';
import {Title} from '@angular/platform-browser';
import {NavigationEnd, Router} from '@angular/router';
import {SubscriptionsContainer} from '../shared/subscriptions-container';
import {CookieService} from 'ngx-cookie-service';
import {ConfirmModalComponent} from '../ui-components/confirm-modal/confirm-modal.component';
import {environment} from '../../environments/environment';
import {SimpleSizeDatastoreService} from '../commercial-sizer/services/simple-size-datastore.service';
import { DataStoreService } from 'src/shared/data-store/data-store.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() changedOppList = new EventEmitter<any>();
  version: string;
  headerString: string;
  userDetail: any;
  nodePrefList: any;
  resiliencyList: any;
  locationList: any;
  prePolicyList: any;
  bsModalRef: BsModalRef;
  opportunityList: any;
  errMsg: any;
  isBetaServer = false;
  displayViewAsEmail: boolean;
  showUserDetails = false;
  inOppPage: any;
  subs = new SubscriptionsContainer();
  emailId: string;
  environment = environment;
  opportunityId:string|null=null;
  showTextArea = false;
  isSubmitClicked= false;
  responseBugText = '';
  headerLogo: string = "";
  notesButtonLink = "https://partners.cohesity.com/partners/s/cohesity-academy/wst-web-sizing-tool-release-notes";
  notesButtonText = "Release Notes";
  /** Link to NodeForge — updated when route/opportunity context changes. */
  newUiHref = this.buildNewUiHref();
  /**
   * Starts hidden; set to true by refreshModernUiStatus() once user details
   * confirm a Cohesity employee on a NodeForge-enabled, non-Simple-Sizer build.
   * This prevents a brief flash of the button before identity is known.
   */
  showNewWstUiButton = false;

  public showRequestNewWSTUIAccessButton: boolean = false;
  public showRequestNewWSTUIAccessPending: boolean = false;
  public showRequestNewWSTUIAccessRejected: boolean = false;

  constructor(public configService: ConfigService,
              private ds: DataStoreService,
              private headerService: HeaderService,
              private titleService: Title,
              private bsModalService: BsModalService,
              private router: Router,
              private cookieService: CookieService,
              public  simpleSizerDS: SimpleSizeDatastoreService,
              private renderer: Renderer2,
              private http: HttpClient) {

    this.configService.userDetails.subscribe(user_detail => {
      this.userDetail = user_detail;
      if ((!this.cookieService.check('wstVersion') || this.cookieService.get('wstVersion') === this.version) && this.userDetail !== undefined && this.userDetail.ENABLE_EULA !== undefined && this.userDetail.ENABLE_EULA) {
        this.eulaPopup();
      }
      if (this.userDetail) {
        this.configService.setUserDetails(this.userDetail);
        this.simpleSizerDS.onSimpleSizerActivated();
        this.refreshModernUiStatus();
      }
      this.showUserDetails = this.userDetail.viewpoint;
      this.setUserForDocs();
      this.simpleSizerDS.onSimpleSizerActivated();
    });
    this.setOpportunityId()
  }

  ngOnInit() {
    this.simpleSizerDS.isSimpleSizer$.subscribe(currentValue => {
      this.updateHeaderForCommercialSizer();
    });
  }

  eulaPopup() {
    if (this.userDetail.settings !== undefined && this.userDetail.settings.eula_datetime !== undefined) {
      const self = this;
      const month = [1, 4, 7, 10];
      const initialState = {
        title: 'EULA',
        message: 'Accept EULA?',
        okBtnMsg: 'Agree',
        hideClose: true
      };
      const today = (new Date()).toLocaleDateString('en-US');
      if (self.userDetail.settings.eula_datetime.length === 0 || ((parseInt(today.split('/')[1]) === 1) && (month.indexOf(parseInt(today.split('/')[0])) !== -1) && (today !== this.userDetail.settings.eula_datetime))) {
        self.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
          ignoreBackdropClick: true,
          class: 'position-center',
          keyboard: false,
          initialState
        });
        self.subs.add = self.bsModalRef.content.onClose.subscribe(modalData => {
          if (modalData !== undefined) {
            const payload = JSON.parse(JSON.stringify(self.userDetail));
            payload.settings.eula_datetime = today;
            delete payload.ENABLE_EULA;
            self.configService.putUserDetails(payload).subscribe((response) => {
              self.userDetail = response;
              self.configService.setUserDetails(self.userDetail);
              this.simpleSizerDS.onSimpleSizerActivated();
            });
          }
        }, error => {
          if ((!this.cookieService.check('wstVersion') || this.cookieService.get('wstVersion') === this.version) && this.userDetail !== undefined && this.userDetail.ENABLE_EULA !== undefined && this.userDetail.ENABLE_EULA) {
            this.eulaPopup();
          }
        });
      }
    }
  }

  ngAfterViewInit() {

    if ((window.location.hash).includes('opportunities')) {
      this.inOppPage = true;
    } else {
      this.inOppPage = false;
    }
    const host = window.location.host;
    if (host !== undefined) {
      if ((host).includes('34.71.27.4')) {
        this.isBetaServer = true;
      }
    }
    this.headerString = environment.headerString;
    if (environment.isIBMInstance) {
      this.emailId = 'ibm_wst_support@cohesity.com';
      this.headerLogo = "assets/images/ibm-defender-white-logo.svg"
    } else {
      this.emailId = 'wst_support@cohesity.com';
      this.headerLogo = "assets/images/cohesity-white-logo.svg"
    }
    this.subs.add = this.configService.getVersion()
      .subscribe((response: { version: string }) => {
        this.version = response.version;
        this.configService.setVersion(this.version);
        this.titleService.setTitle('Cohesity WST ' + this.version);
        this.checkForCookie();
      });
    this.subs.add = this.configService.getAWSRegionList()
      .subscribe((response) => {
      const regionList = [];
      for (const key in response) {
        regionList.push({
          regionKey: key,
          name: response[key]
        });
      }
      this.configService.setAwsRegionList(regionList);
    });
    this.subs.add = this.configService.getPrePolicyList().subscribe((response) => {
      this.prePolicyList = response;
      this.prePolicyList.map(pol => pol.editDisable = true);
      this.configService.setPrepolicyListData(this.prePolicyList);
    });
    this.subs.add = this.configService.getResiliencyList().subscribe((response) => {
      let resList = [];
      for (const key in response) {
        if (response.hasOwnProperty(key)) {
          const resDat = {
            name: key,
            resList: []
          };
          for (const reskey in response[key]) {
            if (response[key].hasOwnProperty(reskey)) {
              resDat.resList.push({
                'res': reskey,
                'node': response[key][reskey]
              });
            }
          }
          resDat.resList = resDat.resList.sort(function (a, b) {
            if (a['res'].toLowerCase() < b['res'].toLowerCase()) {
              return -1;
            } else if (a['res'].toLowerCase() > b['res'].toLowerCase()) {
              return 1;
            } else {
              return;
            }
          });
          resList.push(resDat);
          resList = resList.sort(function (a, b) {
            if (a['name'].toLowerCase() < b['name'].toLowerCase()) {
              return -1;
            } else if (a['name'].toLowerCase() > b['name'].toLowerCase()) {
              return 1;
            } else {
              return;
            }
          });
        }
      }
      this.resiliencyList = resList;
      this.configService.setResiliencyList(this.resiliencyList);
      this.ds.setResiliencyList(this.resiliencyList);
    }, error => {
    });
    this.subs.add = this.configService.getLocationList().subscribe((response) => {
      let locList = [];
      for (const key in response) {
        const locDat = {
          label: key,
          cost: response[key]
        };
        if (response.hasOwnProperty(key)) {
          locList.push(locDat);
          locList = locList.sort(function (a, b) {
            if (a['label'].toLowerCase() < b['label'].toLowerCase()) {
              return -1;
            } else if (a['label'].toLowerCase() > b['label'].toLowerCase()) {
              return 1;
            } else {
              return;
            }
          });
        }
      }
      this.locationList = locList;
      this.configService.setLocationList(this.locationList);
      this.ds.setLocationModelList(this.locationList)
    }, error => {
    });
    this.subs.add = this.configService.getClusterSoftwareVersions().subscribe((response) => {
      this.configService.setClusterSoftwareVersionList(response);
    }, error => {
    });
    this.subs.add = this.configService.getUseCaseTypeList()
      .subscribe((response) => {
      const useCasePref = [];
      const workloadArray = Array.isArray(response) ? response : Object.values(response);
      workloadArray.map(useCase => {
        const data = {
          name: useCase[0][0],
          key: useCase[0][1],
          visibility: useCase[0][2],
          subType: []
        };
        useCase[1].map(subData => {
          data.subType.push({
            name: subData[0],
            key: subData[1],
            visibility: subData[2]
          });
        });
        useCasePref.push(data);
      });
      this.configService.setUseCaseTypeListData(useCasePref);
    }, error => {
    });


  }

  analyticsPage() {
    this.router.navigate(['/analytics/']);
  }

  onOpportunityAssign() {
    const self = this;
    this.opportunityList = this.configService.opportunityData;
    const initialState = {
      'opportunityList': this.opportunityList
    };
    // this.headerService.setOppList(this.opportunityList);
    this.bsModalRef = this.bsModalService.show(AssignOppModalComponent, {
      ignoreBackdropClick: true,
      keyboard: false,
      initialState
    });
    this.subs.add = this.bsModalRef.content.onClose.subscribe(modalData => {
      if (modalData !== undefined) {
        this.changedOppList.emit(modalData);
      }
    });

  }

  onOpportunityTranfer() {
    this.bsModalRef = this.bsModalService.show(TransferOppModalComponent, {ignoreBackdropClick: true, keyboard: false});
    this.subs.add = this.bsModalRef.content.onClose.subscribe(modalData => {
      if (modalData !== undefined) {
        this.changedOppList.emit(modalData);
      }
    }, error => {
      this.errMsg = error.error['error_msg'];
    });
  }

  onViewAs() {
    this.subs.add = this.headerService.getAllEmailIds().subscribe(response => {
      if (response !== undefined) {
        const initialState = {
          'emailIds': response.email === undefined ? [] : response.email
        };
        this.bsModalRef = this.bsModalService.show(ViewAsModalComponent, {
          ignoreBackdropClick: true,
          keyboard: false,
          initialState
        });
        this.subs.add = this.bsModalRef.content.onClose.subscribe(modalData => {
          this.showUserDetails = false;
          if (modalData !== undefined) {
            this.userDetail = modalData;
            this.changedOppList.emit({
              'user': this.userDetail
            });
            this.displayViewAsEmail = true;
            this.showUserDetails = this.userDetail.viewpoint;
          }
        }, error => {
          this.errMsg = error.error['error_msg'];
        });
      }
    });
  }

  onViewAsAdmin() {
    this.displayViewAsEmail = false;
    const payload = {
      'viewas': 'admin'
    };
    this.subs.add = this.headerService.viewAs(payload).subscribe(user => {
      this.simpleSizerDS.onSimpleSizerActivated();
      this.changedOppList.emit({
        'user': {
          'role': 'admin'
        }
      });
      this.showUserDetails = false;
    }, err => {
    });
  }

  nodeInformation() {
    this.router.navigate(['/nodeInformation/']);
  }

  onIconClick() {
    if ((window.location.hash).includes('opportunities')) {
      this.inOppPage = true;
    } else {
      this.inOppPage = false;
    }
    this.showTextArea =true ;
  }

  checkForCookie() {
    if (!this.cookieService.check('wstVersion')) {
      this.cookieService.set('wstVersion', this.version, null, '/', null, null, null);
    } else {
      if (this.cookieService.get('wstVersion') !== this.version) {
        const tempWstVersion = this.cookieService.get('wstVersion');
        this.cookieService.delete('wstVersion', '/index.html');
        if (!this.cookieService.check('wstVersion')) {
          this.cookieService.set('wstVersion', tempWstVersion, null, '/', null, null, null);
        }
        const initialState = {
          title: 'Web Sizing Tool',
          message: `New WST version: ${this.version} has been deployed.`,
          okBtnMsg: 'OK',
          hideClose: true
        };
        this.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
          ignoreBackdropClick: true,
          class: 'position-center',
          keyboard: false,
          initialState
        });
        this.subs.add = this.bsModalRef.content.onClose.subscribe(modalData => {
          window.location.reload();
          if (modalData !== undefined) {
            this.cookieService.set('wstVersion', this.version, null, '/', null, null, null);
            if (this.userDetail !== undefined && this.userDetail.ENABLE_EULA !== undefined && this.userDetail.ENABLE_EULA) {
              this.eulaPopup();
            }
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.subs.dispose();
  }

  private copyWSTIDToClipboard() {
    const input = document.createElement('input');
    input.setAttribute('value', this.opportunityId);
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
  }

  private updateHeaderForCommercialSizer() {

    if (this.simpleSizerDS.state.isSimpleSizer === true) {
      this.headerString = environment.headerStringForSimpleSizer;
      this.emailId = `simplesizer@cohesity.com`;
    }
  }

  logoClickHandler(){
    if(this.simpleSizerDS.state.isSimpleSizer === true){
      this.router.navigate(['/all-opportunities'])
      return;
    }
    this.router.navigate(['/opportunities'])
  }
  setOpportunityId() {
    this.syncOpportunityIdFromLocation();
    this.subs.add = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.syncOpportunityIdFromLocation();
      }
    });
  }

  /**
   * NodeForge mount prefix for building links from legacy Angular.
   * Local Angular dev (:4201) → Vite on :4200. Local Vite same-origin (:4200) → ''.
   * Deployed: `environment.nodeForgeHref` (typically `/v2`).
   */
  private getNodeForgeMountPrefix(): string {
    const { hostname, port, protocol } = window.location;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
    if (isLocal && port === '4201') {
      return `${protocol}//${hostname}:4200`;
    }
    if (isLocal && port === '4200') {
      return '';
    }
    const href = (environment as { nodeForgeHref?: string }).nodeForgeHref || '/v2/';
    return href.replace(/\/$/, '');
  }

  /**
   * Default SmartSizer entry when not deep-linking to an opportunity.
   * Always use an explicit route (/dashboard or /v2/dashboard), never bare `/` or `/v2/`,
   * so users with legacy default-landing preference can still open NodeForge from legacy.
   */
  private getNodeForgeHomeHref(): string {
    const prefix = this.getNodeForgeMountPrefix();
    if (!prefix) {
      return '/dashboard';
    }
    if (prefix.startsWith('http://') || prefix.startsWith('https://')) {
      return `${prefix}/dashboard`;
    }
    return `${prefix}/dashboard`;
  }

  /**
   * Build NodeForge link from legacy context.
   * When viewing an opportunity (`/#/site/:id`), open that opportunity in NodeForge
   * instead of the dashboard root.
   */
  private buildNewUiHref(opportunityId: string | null = this.opportunityId): string {
    if (!opportunityId) {
      return this.getNodeForgeHomeHref();
    }
    const prefix = this.getNodeForgeMountPrefix();
    return `${prefix}/opportunity/${opportunityId}`;
  }

  private updateNewUiHref(): void {
    this.newUiHref = this.buildNewUiHref();
  }

  private syncOpportunityIdFromLocation(): void {
    const hash = window.location.hash;
    const siteMatch = hash.match(/#\/site\/(\d+)/);
    if (siteMatch) {
      this.opportunityId = siteMatch[1];
    } else {
      const hashes = hash.split('/');
      const lastSegment = hashes[hashes.length - 1];
      const isNumber = !isNaN(Number(lastSegment));
      this.opportunityId = isNumber ? lastSegment : null;
    }
    this.updateNewUiHref();
  }
  onSubmit(form :any) {
    if(form.valid){
    this.isSubmitClicked= true;
    const body =`Hi, Below are the list of issues faced while using Cohesity Sizing Tool.

Opp Id:
${this.opportunityId ? this.opportunityId:'N/A'}

Version: 
${this.version}
    
Description: 
${this.responseBugText}`;
    const subject = `Cohesity WST ${this.version} Bug Report - Opp Id: ${this.opportunityId ? this.opportunityId:'N/A'}`;
    const mailtoLink = `mailto:${this.emailId}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    // Create a temporary anchor element to trigger the mailto link
    const tempLink = document.createElement('a');
    tempLink.href = mailtoLink;
    tempLink.click();
    setTimeout(() => { //This settimeout is time for textarea to refresh. It is also time thank-you-message stays
      this.showTextArea = false;
      this.isSubmitClicked= false;
      this.responseBugText = '';
      document.body.removeChild(tempLink);
    }, 11000);}
  }

  /**
   * Checks if the logged in user is a Cohesity employee by verifying if their email ends with '@cohesity.com'.
   * This is used to determine the appropriate documentation link to display in the header.
   * 
   * @returns boolean - true if the user is a Cohesity employee, false otherwise.
   */
  isCohesityUser(): boolean {
    const email = this.userDetail?.email || '';
    return email.toLowerCase().endsWith('@cohesity.com');
  }

  /**
   * Sets the documentation link and button text in the header based on whether the logged in user is a Cohesity employee or not.
   * If the user is a Cohesity employee, the button will display "What's New" and link to the internal "What's New" page.
   * If the user is not a Cohesity employee, the button will display "Release Notes" and link to the public release notes page.
   * This method is called during component initialization and whenever user details are updated to ensure the correct link is displayed.
   */
  setUserForDocs() {
    if(this.isCohesityUser()){
      this.notesButtonText = "What's New";
      this.notesButtonLink = environment.whatsNewLink;
    }
    else {
      this.notesButtonText = "Release Notes";
      this.notesButtonLink = "https://partners.cohesity.com/partners/s/cohesity-academy/wst-web-sizing-tool-release-notes";
    }
  }

  /**
   * Local visibility for the New WST UI button — no enrollment/status API.
   *
   * Hidden for Simple Sizer, IBM (``environment.isNodeForgeEnable``), and
   * non-@cohesity.com users. Request/pending/rejected states stay off.
   */
  refreshModernUiStatus(): void {
    this.showRequestNewWSTUIAccessButton = false;
    this.showRequestNewWSTUIAccessPending = false;
    this.showRequestNewWSTUIAccessRejected = false;
    this.showNewWstUiButton =
      !this.simpleSizerDS.state.isSimpleSizer &&
      !!environment.isNodeForgeEnable &&
      this.isCohesityUser();
  }

  public requestNewWSTUIAccess(): void {
    const url = '/envsetup/modern-ui/request';
    if (!confirm('Send a request for New WST UI access? An administrator will review it.')) {
      return;
    }
    this.http.post(url, {}).subscribe(
      () => {
        this.showRequestNewWSTUIAccessButton = false;
        this.showRequestNewWSTUIAccessPending = true;
        alert('Request submitted. You will be notified once an admin approves it.');
      },
      (err: any) => {
        const msg = err?.error?.error || 'Request failed. Please try again.';
        alert(msg);
      }
    );
  }
}
